import { Injectable } from '@angular/core';
import { BaseclientService } from '../../apiclient/baseclient.service';
import { ToolsService } from '../../tools/tools.service';


@Injectable({
  providedIn: 'root'
})

export class DeviceCheck {

  constructor(
    private baseClient: BaseclientService,
    private tools: ToolsService
  ) { }

  /**
   * Envoi d'un ordre de commande à table
   * Dans le cas d'une commande à table, on doit attendre la réponse de la caisse Android
   * @param data
   */
  setOrderIntentDeviceCheck(data: any): Promise<any> {

    const params = {
      "id_point_of_sale": data.id_point_of_sale,
      'id_order': data.order_id_device,
      'id_merchant' : this.tools.getStor("id_merchant")
    }

    return this.baseClient.postBase("order_intent_device_check", params);
  }

  /**
    * @description get Status OrderIntent
    * @param data
    */

  getStatusOrderIntent(data: any): Promise<any> {

    const params = {
      "order_intent_id": data.order_intent_id,
      "id_point_of_sale": data.id_point_of_sale,
      'id_order': data.order_id_device,
      'id_merchant' : this.tools.getStor("id_merchant")
    };


    return this.baseClient.postBase("status_order_intent_device_check", params);
  }



  /**
  * @description set PaymentSucceeded by id_webshop
  * @param data
  * @param pay_intent
  */
  DeviceCheckPaymentSucceeded(data: any): Promise<any> {

    const params = {
      "order_intent_id": data.order_intent_id,
      "id_point_of_sale": data.id_point_of_sale,
      'id_order': data.order_id,
      'id_merchant' : this.tools.getStor("id_merchant")
    };

    return this.baseClient.postBase("succeeded_device_check", params);
  }















}
